export const LOGIN_INITIAL = "LOGIN_INITIAL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const SET_TOKEN = "SET_TOKEN";
